
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { Collection } from '@api/api';
import { CollectionCard } from '@components/common/Card/CollectionCard';
import { DataFeed } from '@components/common/DataFeed';
import { Seo } from '@components/common/Seo';
import { useCurrentPaginationPage, usePagination } from '@hooks/usePagination';
import { fetchCollections, useCollections } from '@queries/useCollections';
import { fetchCollectionsCount } from '@queries/useCollectionsCount';
import { buildCollectionPageLink, buildCollectionsPageLink } from '@utils/link';
import { withGlobalSettings } from '@utils/pageFetchEnhancer';
import { buildOpenGraph, buildResourceSeoSettings } from '@utils/seo';
import { GetStaticProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import { ReactElement } from 'react';
import { dehydrate } from 'react-query';
import { PageProps } from '../../types/page';

export default function CollectionsPage({ seo }): ReactElement {
  const { t } = useTranslation('collections');

  const currentPage = useCurrentPaginationPage();
  const { data: articles, totalPages, isFetching } = useCollections(currentPage);
  const { onPageChange } = usePagination(currentPage, totalPages);

  const url = buildCollectionsPageLink();

  return (
    <>
      {/* TODO: it would be a good idea to allow manging collections page seo from CMS */}
      <Seo
        canonical={url}
        siteName={seo.siteName}
        metaTitle="Collections"
        metaDescription="List of collections."
        openGraph={buildOpenGraph({
          url,
          type: 'website',
          sitename: seo.siteName,
          description: 'List of collections.',
          title: 'Collections',
        })}
      />
      <DataFeed<Collection>
        data={(articles as { items?: Collection[] })?.items}
        loading={isFetching}
        name={t('collections')}
        subname={t('all-collections')}
        loadMoreText={t('load-more')}
        renderData={(collection) => (
          <CollectionCard
            key={collection.id}
            collection={collection}
            href={buildCollectionPageLink(collection.slug)}
          />
        )}
        onPageChange={onPageChange}
        totalPages={totalPages}
        activePage={currentPage}
      />
    </>
  );
}

 const _getStaticProps: GetStaticProps = withGlobalSettings<PageProps>(
  async (nextContext, { queryClient, globalSettingsPromise, adScriptsPromise }) => {
    const [globalSettings, adScripts] = await Promise.all([
      globalSettingsPromise,
      adScriptsPromise,
      queryClient.prefetchQuery('collections-count', () => fetchCollectionsCount()),
      queryClient.prefetchQuery(['collections', 0], () => fetchCollections({})),
    ]);

    const seo = buildResourceSeoSettings(
      {
        ...globalSettings.global.seo,
        siteName: globalSettings.global.siteName,
      },
      { id: '' },
    );

    return {
      props: {
        dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
        seo,
        adScripts,
        globalSettings,
      },
    };
  },
);


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/collections/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  